import { render, staticRenderFns } from "./SingleLayerPopupInfos.vue?vue&type=template&id=c209a136&scoped=true"
import script from "./SingleLayerPopupInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerPopupInfos.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c209a136",
  null
  ,true
)

export default component.exports